document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-variant-select]')) return;
  const select = event.target, option = select.selectedOptions[0];
  const container = select.closest('.sf-product-grid');
  if (!option || !container) return;
  const available = option.dataset.available === 'true';
  container.querySelector('[data-product-price]').textContent = option.dataset.price;
  const compare = container.querySelector('[data-compare-price]');
  if (compare) compare.hidden = true;
  const button = container.querySelector('[data-add-button]');
  button.disabled = !available;
  button.textContent = available ? 'Add to cart' : 'Sold out';
  container.querySelector('[data-product-status]').textContent = available ? '' : 'This option is currently unavailable.';
  const url = new URL(window.location.href);
  url.searchParams.set('variant', select.value);
  window.history.replaceState({}, '', url);
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.site-header details[open]').forEach(detail => { detail.open = false; detail.querySelector('summary').focus(); });
});
